import { Component, RefObject } from "react";

import { FilteredResource } from "@app/resources";
import { EditProject } from "./EditProject";
import { FlyoutLink } from "@app/shared/Flyouts";

interface EditProjectOptionsLinkProps {
  containerId: string;
  disabled: boolean;
  filteredProjectResource: FilteredResource;
  /** Force updateState() call */
  forceUpdateProject?: () => Promise<void>;
  onUpdateProjectOptions: (filteredResource?: FilteredResource) => Promise<void>;
  setProjectIsReadOnly?: (projectIds: number[]) => void;
  triggerElementOverride?: RefObject<HTMLButtonElement>;
}

interface EditProjectOptionsLinkState {
  projectOptionsDirty: boolean;
  triggerClose: () => void;
}

class EditProjectOptionsLink extends Component<EditProjectOptionsLinkProps, EditProjectOptionsLinkState> {

  constructor(props: EditProjectOptionsLinkProps) {
    super(props);

    this.state = {
      projectOptionsDirty: false,
      triggerClose: null,
    };
  }

  public render() {
    return (
      <FlyoutLink
        classNames="action-menu-item col-12 font-weight-normal"
        content={{
          body: (() => this.renderEditContent())(),
          title: "Project Options",
        }}
        modalContent={{
          body: "You will lose unsaved changes. Continue with closing the sidebar?",
          cancelButtonText: "Cancel",
          confirmButtonText: "Continue",
          title: "Warning",
        }}
        size="80"
        testId="edit-project-options-link__flyout-link"
        warnOnClose={this.state.projectOptionsDirty}
        onClose={this.handleExited}
        triggerElementOverride={this.props.triggerElementOverride}
      >
        <i className="fa fa-pencil-square-o" /> Project Options
      </FlyoutLink>
    );
  }

  private renderEditContent() {
    return (
      <EditProject
        sidePanelId={this.props.containerId}
        disabled={this.props.disabled}
        onChange={this.handleProjectOptionsChange}
        projectId={this.props.filteredProjectResource.resourceId}
        onRunProjectSuccess={this.handleRunProjectSuccess}
        onSubmitSuccess={this.handleSubmitSuccess}
      />
    );
  }

  private handleSubmitSuccess = async () => {
    if (this.state.projectOptionsDirty) {
      await this.props.onUpdateProjectOptions(this.props.filteredProjectResource);
    }
  }

  private handleRunProjectSuccess = async () => {
    this.props.setProjectIsReadOnly([this.props.filteredProjectResource.resourceId]);
  }

  private handleProjectOptionsChange = (projectOptionsDirty: boolean) => {
    if (this.state.projectOptionsDirty !== projectOptionsDirty) {
      this.setState({ projectOptionsDirty });
    }
  }

  private handleExited = async () => {
    if (this.props.forceUpdateProject) {
      await this.props.forceUpdateProject();
    }
    this.setState({
      projectOptionsDirty: false,
    })
  }

}

export { EditProjectOptionsLink };
